export function hasChildren(item) {
    const { items: children } = item;
    // console.log("this is checking has children", typeof item, item, children)

    if (children === undefined) {
        return false;
    }

    if (children.constructor !== Array) {
        return false;
    }

    if (children.length === 0) {
        return false;
    }

    return true;
}
